import authService from "./identity/auth-service";
import log from "./log";
import globalState from "@/shared/global-state";

const createHiddenInput = (name, value) => {
  const input = document.createElement("input");
  input.type = "hidden";
  input.name = name;
  input.value = value;
  return input;
};

const createForm = (redirectUri, idToken, state) => {
  const form = document.createElement("form");
  form.style.position = "absolute";
  form.action = `${globalState.launchConfig.identityUrl}/api/manage/external/append`;
  form.method = "POST";
  form.enctype = "application/x-www-form-urlencoded";

  form.appendChild(createHiddenInput("redirect_uri", redirectUri));
  form.appendChild(createHiddenInput("id_token", idToken));
  form.appendChild(createHiddenInput("external_provider", "esia"));
  form.appendChild(createHiddenInput("state", state));

  return form;
}

const attachEsiaRedirect = async (backRoute = null) => {
  const user = await authService.getIdentityUser();
  if (!user) {
    throw new Error("User not found");
  }
  const form = createForm(
    window.location.origin + "/attach-external-callback",
    user.id_token,
    backRoute ? JSON.stringify(backRoute) : ""
  )
  document.body.appendChild(form);
  form.submit();
}

export default {
  verifyPopup() { },
  async verifyRedirect(backRoute = null) {
    try {
      await attachEsiaRedirect(backRoute);
    } catch (e) {
      log.error(e);
      throw e;
    }
  }
}
